import { action, observable } from 'mobx';
import { HttpClient } from 'Mri.Web.Common';

export class WeatherStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadWeatherAsync(serialNumber: string) {
        const weather = await this.httpClient.get<any>(`/api/v1/weather/${serialNumber}`);

        if (weather) this.weathers.set(serialNumber, weather);
    }

    @observable
    public weathers = new Map<string, any>();

    private readonly httpClient: HttpClient;
}
